<template>
  <div class="page-content ride-search-page">
    <div class="row">
      <div class="col-12">
        <ride-search-table />
        <ride-detail v-if="rideId" />
      </div>
      <div class="col-12">
        <ride-activities />
        <ride-estimation />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useRide } from '@/use/ride';

const RideSearchTable = defineAsyncComponent(() => import('./RideSearch/RideSearch.vue') as any);

const RideActivities = defineAsyncComponent(() => import('./RideSearch/RideActivities.vue') as any);

const RideEstimation = defineAsyncComponent(() => import('./RideSearch/RideEstimation.vue') as any);

const RideDetail = defineAsyncComponent(() => import('./RideSearch/RideDetail.vue') as any);

const { rideId } = useRide();

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
